import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"search\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.669 12.234a5.25 5.25 0 1 1 .566-.566l4.548 4.549a.4.4 0 0 1-.566.566l-4.548-4.549ZM12.7 8.25a4.45 4.45 0 1 1-8.9 0 4.45 4.45 0 0 1 8.9 0Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol